var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 15.8333H19.1668V17.5H0.833496V15.8333H2.50016V3.33333C2.50016 2.8731 2.87326 2.5 3.3335 2.5H11.6668C12.1271 2.5 12.5002 2.8731 12.5002 3.33333V15.8333H15.8335V9.16667H14.1668V7.5H16.6668C17.1271 7.5 17.5002 7.8731 17.5002 8.33333V15.8333ZM4.16683 4.16667V15.8333H10.8335V4.16667H4.16683ZM5.8335 9.16667H9.16683V10.8333H5.8335V9.16667ZM5.8335 5.83333H9.16683V7.5H5.8335V5.83333Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingLine);
export default __webpack_public_path__ + "static/media/building-line.d17fcbd2d90130f8a32951c577305b0a.svg";
export { ForwardRef as ReactComponent };